import * as Mutation from './mutation-types'
import SalaAulaAPI from '@/api/sala-aula-api'

export default {
  async ementaIdConcluida ({ commit }, ementaIdConcluida) {
    commit(Mutation.SET_EMENTA_ID_CONCLUIDA, ementaIdConcluida)
  },
  async concluiEmentaVideo ({ commit, getters }, { ementaId, tempoAtual, tempoTotal }) {
    let tempoAtualPorcentagem = (tempoAtual * 100) / tempoTotal
    let porcentagemMinimaConclusaoVideo = 90

    if (getters.empresa.porcentagemMinimaConclusaoVideo) {
      porcentagemMinimaConclusaoVideo = getters.empresa.porcentagemMinimaConclusaoVideo
    }

    if (tempoAtualPorcentagem >= porcentagemMinimaConclusaoVideo && getters.ementaIdConcluida !== ementaId) {
      SalaAulaAPI.atualizarVisualizacaoTopico(ementaId, 1).then(() => {
        commit(Mutation.SET_EMENTA_ID_CONCLUIDA, ementaId)
      })
    }
  }
}
